import type { ZodType } from 'zod';

export const getImportResultStorageKey = (
  baseKey: string,
  userEntityRef: string,
): string => `${baseKey}:${encodeURIComponent(userEntityRef)}`;

export const readImportResult = <Result>(
  storageKey: string,
  schema: ZodType<Result>,
): Result | undefined => {
  try {
    const storedResult = globalThis.sessionStorage?.getItem(storageKey);
    if (!storedResult) {
      return undefined;
    }

    const parsedResult = schema.safeParse(JSON.parse(storedResult));
    return parsedResult.success ? parsedResult.data : undefined;
  } catch {
    return undefined;
  }
};

export const storeImportResult = <Result>(
  storageKey: string | undefined,
  result?: Result,
): void => {
  if (!storageKey) {
    return;
  }

  try {
    if (result) {
      globalThis.sessionStorage?.setItem(storageKey, JSON.stringify(result));
    } else {
      globalThis.sessionStorage?.removeItem(storageKey);
    }
  } catch {
    // Browser storage may be unavailable; the banner still works in-page.
  }
};
